const ko = {
  salePrice: "판매가",
  maPrice: "총 재료 가격",
  finallyPrice: "이익",
  purePrice: "순이익",
  priceCheck: "비용 계산",

  save: '저장',
  saveSuccess: '계산 데이터가 업데이트되었습니다',
  saveError: '계산 데이터 업데이트 실패',
  saveTip: '저장 확인',
  saveTipContent: '수정된 할인 및 커미션 비율을 저장하시겠습니까?',
  costUpdate: '비용 계산 데이터가 변경되었습니다',
  costUpdateTip: '변경 사항을 취소하시겠습니까?'
};

export default ko;